import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ICalendarEventResource } from "../types";

export interface ICalendarEventQueryParameters {
    calendarEvent?: RelationalValue<ICalendarEventResource>;
}

export type ICalendarEventQueryResult = ICalendarEventResource;

export const calendarEventQuery: IApiQueryFunction<ICalendarEventQueryParameters> = ({ calendarEvent }) => {
    if (!calendarEvent) {
        return;
    }

    return {
        method: "GET",
        url: `/calendar-events/${mapRelationalValue(calendarEvent)}`,
    };
};

export const useCalendarEventQuery = createApiQueryHook<ICalendarEventQueryParameters, ICalendarEventQueryResult>(
    calendarEventQuery,
);
